module.exports = __webpack_public_path__ + "static/media/LivrosAberta.2ea63ab0.png";